import { render, staticRenderFns } from "./image-placeholder.html?vue&type=template&id=6d5cb60a&scoped=true&"
import script from "./image-placeholder.js?vue&type=script&lang=js&"
export * from "./image-placeholder.js?vue&type=script&lang=js&"
import style0 from "./image-placeholder.scss?vue&type=style&index=0&id=6d5cb60a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5cb60a",
  null
  
)

export default component.exports